export default "__VITE_ASSET__Qg76gij9__"